import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";

export const PublicRoute = ({ component: Component, ...rest }) => {
  const { token } = useSelector((store) => ({
    token: store.authReducer?.token,
  }));

  return (
    <>
      <Route
        {...rest}
        render={(props) => {
          return token.length == 0 ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: props.location },
              }}
            />
          );
        }}
      />
    </>
  );
};

export default PublicRoute;
